<template>
  <div>
    <div class="table-responsive">
      <table class="table table-striped table-bordered table-condensed" :bordered="true">
        <thead>
        <tr>
          <th v-for="tableHeader in tableHeaders" :key="tableHeader.value">
            {{ tableHeader.text }}
          </th>
        </tr>
        </thead>
        <tbody>
          <tr v-for="(role, roleIndex) in roleWithPermissions" :key="role.clientType['@id']">
            <th>{{ role.clientType.title }}</th>
            <td v-for="(permission, index) in role.permissions" :key="permission[index]">
              <b-form-checkbox v-model="roleWithPermissions[roleIndex].permissions[index].value"></b-form-checkbox>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="roleOptions">
      <hr class="my-2">
      <span class="h6">{{ $t('views.excmtasktype.form.hiddenCaseForRoles') }}:</span>
      <multi-select :options="roleOptions" :selected-options="disabledRoles" @select="selectDisabledRoleHandler"></multi-select>
    </div>
    <div v-if="taskTypeOptions">
      <hr class="my-2">
      <span class="h6">{{ $t('views.excmtasktype.form.conditionsAdd') }}:</span>
      <multi-select :options="taskTypeAllowedOptions" :selected-options="conditionsAdd" @select="selectConditionsAddHandler"></multi-select>
    </div>
  </div>
</template>

<script>
import ApiService from '@/utils/ApiService'
import { MultiSelect } from 'vue-search-select'
import getId from '@/utils/getIdFromLink'
import { mapGetters } from 'vuex'

export default {
  name: 'CreateRolesForTaskType',

  components: {
    MultiSelect
  },

  props: {
    initialRoleWithPermissions: {
      type: Array,
      default: () => []
    },
    values: Object
  },

  computed: {
    ...mapGetters({
      taskTypeOptions: 'excmtasktype/list/getTaskTypeOptions'
    }),
    taskTypeAllowedOptions () {
      return this.taskTypeOptions.map(option => {
        return { value: getId(option.value), text: option.text + (option.idCasesType ? ' (' + option.idCasesType.title + ')' : '') }
      })
    },
    item () {
      return this.values
    },
    isUpdate () {
      return this.$route.name === 'EXCMTaskTypeUpdate'
    }
  },

  data () {
    return {
      disabledRoles: [],
      conditionsAdd: [],
      lastSelectedDisabledRole: {},
      lastSelectedConditionsAdd: {},
      roleOptions: [],
      items: [],
      isLoading: true,
      roleWithPermissions: [],
      singlePermissions: [
        {
          value: false,
          text: 'create'
        },
        {
          value: false,
          text: 'read'
        },
        {
          value: false,
          text: 'read2'
        },
        {
          value: false,
          text: 'update'
        },
        {
          value: false,
          text: 'take'
        },
        {
          value: false,
          text: 'delete'
        },
        {
          value: false,
          text: 'accessFirm'
        },
        {
          value: false,
          text: 'accessGroup'
        },
        {
          value: false,
          text: 'accessSelf'
        },
        {
          value: false,
          text: 'accessAll'
        }
      ],
      tableHeaders: [
        {
          value: null,
          text: this.$t('views.excmtasktype.form.role')
        },
        {
          value: 'C',
          text: this.$t('views.excmtasktype.form.create')
        },
        {
          value: 'R1',
          text: this.$t('views.excmtasktype.form.read')
        },
        {
          value: 'R2',
          text: this.$t('views.excmtasktype.form.read2')
        },
        {
          value: 'U',
          text: this.$t('views.excmtasktype.form.update')
        },
        {
          value: 'T',
          text: this.$t('views.excmtasktype.form.take')
        },
        {
          value: 'D',
          text: this.$t('views.excmtasktype.form.delete')
        },
        {
          value: 'AF',
          text: this.$t('views.excmtasktype.form.accessFirm')
        },
        {
          value: 'AG',
          text: this.$t('views.excmtasktype.form.accessGroup')
        },
        {
          value: 'AS',
          text: this.$t('views.excmtasktype.form.accessSelf')
        },
        {
          value: 'AA',
          text: this.$t('views.excmtasktype.form.accessAll')
        }
      ]
    }
  },

  watch: {
    'items' () {
      if (!(this.initialRoleWithPermissions.length > 0)) {
        this.getPermissionsArray(this.items)
      }
    },
    'roleWithPermissions' () {
      this.$emit('roleWithPermissions', this.roleWithPermissions)
    }
  },
  created () {
    this.roleWithPermissions = [...this.initialRoleWithPermissions]
    this.getPage()
  },
  methods: {
    initialDisabledRoleHandler () {
      if (this.item.disabledRoles) {
        this.disabledRoles = this.item.disabledRoles.map(role => {
          return this.roleOptions.find(option => option.value === role)
        })
      }
    },
    initialConditionsAddHandler () {
      if (this.item.conditionsAdd) {
        this.conditionsAdd = this.item.conditionsAdd.map(role => {
          return this.taskTypeAllowedOptions.find(option => getId(option.value) === role)
        })
      }
    },
    selectDisabledRoleHandler (disabledRoles, lastSelectedDisabledRole) {
      this.disabledRoles = disabledRoles
      this.item.disabledRoles = disabledRoles.map(role => role.value)
      this.lastSelectedDisabledRole = lastSelectedDisabledRole
    },
    selectConditionsAddHandler (conditionsAdd, lastSelectedConditionsAdd) {
      this.conditionsAdd = conditionsAdd
      this.item.conditionsAdd = conditionsAdd.map(role => role.value)
      this.lastSelectedConditionsAdd = lastSelectedConditionsAdd
    },
    setRoleOptions () {
      this.roleOptions = this.items.map(item => {
        return {
          value: getId(item['@id']),
          text: item.title
        }
      })
    },
    async getPage () {
      let params = {
        pagination: false,
        state: 1
      }
      const response = await new ApiService('client_types', params).getResults()
      this.items = response.items
      this.isLoading = false
      this.items.splice(this.items.findIndex(entry => {
        return entry.title === 'Super User'
      }), 1)
      this.setRoleOptions()
      if (this.isUpdate) {
        this.initialDisabledRoleHandler()
        this.initialConditionsAddHandler()
      }
    },
    createPermissionsObject (item, singlePermissions) {
      return {
        clientType: item,
        permissions: JSON.parse(JSON.stringify(singlePermissions))
      }
    },
    getPermissionsArray (items) {
      items.forEach((entry) => {
        let temp = this.createPermissionsObject(entry, this.singlePermissions)
        this.roleWithPermissions.push(temp)
      })
    }
  }
}
</script>

<style scoped>
  .table td {
    text-align: center;
  }
</style>
